/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-05-17 08:36:40
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-01-07 11:39:32
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import '@/styles/index.scss' // glob scss
import VueClipboard from 'vue-clipboard2'
import VueCropper from 'vue-cropper'
import WebIM from './utils/im/WebIM'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueCropper)
Vue.use(VueClipboard)
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
// 只对 Chrome/Edge 之类浏览器处理，Safari 不建议这样做
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

let rawCanPlayType = null

if (!isSafari) {
  rawCanPlayType = HTMLMediaElement.prototype.canPlayType

  HTMLMediaElement.prototype.canPlayType = function(type) {
    const t = String(type || '').toLowerCase()

    // 禁止浏览器向播放器声明"我可以原生播放 HLS"
    if (
      t.includes('application/vnd.apple.mpegurl') ||
      t.includes('application/x-mpegurl') ||
      t.includes('mpegurl') ||
      t.includes('m3u8')
    ) {
      return ''
    }

    return rawCanPlayType.call(this, type)
  }
}

new Vue({
  router,
  store,
  WebIM,
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App),
}).$mount('#app')
